import React from 'react';
import Icon from '../../../components/AppIcon';

const PromotionsSummaryCard = ({ activeCount, expiringCount }) => {
  return (
    <div className="bg-card rounded-xl p-6 md:p-8 border border-border shadow-warm">
      <div className="flex items-start justify-between mb-6">
        <div>
          <p className="font-caption text-sm text-muted-foreground mb-1">Promozioni Attive</p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground">
            {activeCount}
          </h2>
        </div>
        <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent/20 flex items-center justify-center">
          <Icon name="Tag" size={24} color="var(--color-accent)" />
        </div>
      </div>

      {expiringCount > 0 && (
        <div className="bg-warning/10 border border-warning/30 rounded-lg p-4 flex items-start gap-3">
          <Icon name="AlertCircle" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-body font-medium text-sm text-warning-foreground mb-1">
              {expiringCount} {expiringCount === 1 ? 'promozione scade' : 'promozioni scadono'} presto
            </p>
            <p className="font-caption text-xs text-muted-foreground">
              Usa le tue promozioni prima che scadano
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PromotionsSummaryCard;